import _extends from "@babel/runtime/helpers/esm/extends";
import inputStyles from "../Input/styles";
export var timePickerStyles = function timePickerStyles(theme) {
  return {
    root: {
      display: 'flex',
      width: '100%',
      position: 'relative',
      flexFlow: 'column',
      '&:not([disabled]):hover': {
        '& .picker-input-button': {
          fill: theme.palette.primary["default"]
        }
      }
    },
    menu: {
      maxHeight: 270
    }
  };
};
export var timePickerInputStyles = function timePickerInputStyles(theme) {
  return {
    root: _extends({}, theme.typography.primary, inputStyles.shared(theme), {
      paddingRight: 0,
      paddingLeft: 0,
      '&:hover': _extends({}, inputStyles.hover(theme)),
      height: '46px',
      '&::placeholder': inputStyles.placeholder(theme)
    }),
    clearIcon: {
      color: theme.palette.secondary["default"],
      '&:hover': {
        color: theme.palette.primary["default"]
      }
    },
    row: {
      height: '100%',
      paddingLeft: theme.spacer(3)
    },
    input: {
      width: 25,
      padding: 0,
      border: '0px solid',
      boxShadow: 'none',
      backgroundColor: 'transparent',
      '&:hover': {
        border: '0px solid'
      }
    },
    separator: {
      paddingRight: theme.spacer(1)
    },
    disabled: inputStyles.disabled(theme),
    focus: inputStyles.focused(theme),
    error: inputStyles.error(theme)
  };
};